/**
 * Parses a date-only string ("YYYY-MM-DD") as local midnight, so the calendar
 * day isn't rolled back by `new Date()`'s UTC parsing for users west of UTC
 * (BIK-2080). ISO timestamps and Date instances are passed through to `new Date`
 * unchanged.
 *
 * @param {string | Date} value - A date-only string, an ISO timestamp, or a Date.
 * @returns {Date} A Date at local midnight for date-only input, otherwise `new Date(value)`.
 */
export default function parseDateOnly(value: string | Date): Date {
  if (value instanceof Date) {
    return value;
  }
  const match =
    typeof value === "string" && /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (match) {
    const [, year, month, day] = match;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }
  return new Date(value);
}
